// Home page (pages/index.tsx), the shared voice/collection/collab cards
// (components/home/JamCards.tsx, used site-wide) and the Discord CTA.
// The hero links reuse nav.footer.aiCover / nav.footer.voiceChanger /
// nav.train, and the Discord CTA reuses nav.discordAria / nav.discordJoin.
// See messages/README.md for how to add strings.
export const home = {
  en: {
    "home.seo.title": "Jammable | Create AI Covers with your Favorite Voices!",
    "home.seo.description":
      "Create AI covers in seconds with Jammable, with thousands of community uploaded AI voice models available for creative use now!",
    "home.seo.ogTitle":
      "Jammable | Create AI Covers with Your Favorite Voices | AI-Powered Music Creation",
    "home.seo.imageAlt": "Jammable - Create AI Covers",

    // Hero. The h1 is "Create <highlight>AI covers</highlight> with your
    // favourite voices".
    "home.hero.views": "10 billion+ views on TikTok, YouTube and Instagram",
    "home.hero.titleBefore": "Create",
    "home.hero.titleHighlight": "AI covers",
    "home.hero.titleAfter": "with your favourite voices",
    "home.hero.subtitle":
      "Pick from 100,000+ AI voices, add your audio, and get it back in seconds.",
    "home.hero.decorVoice": "AI voice",
    "home.hero.decorCover": "cover",
    "home.hero.searchLabel": "Search voices",
    "home.hero.searchPlaceholder": "Search 100,000+ voices",
    "home.hero.searchButton": "Search",
    "home.hero.makeCover": "Make a cover",

    "home.categories.all": "See all categories",
    "home.recent": "Jump back in",
    "home.trending": "Trending now",
    "home.seeAll": "See all",

    // "Train your own <highlight>AI voice</highlight>"
    "home.train.kicker": "100,000+ voices started this way",
    "home.train.titleBefore": "Train your own",
    "home.train.titleHighlight": "AI voice",
    "home.train.body":
      "Build a voice from a few samples, then make covers in a voice nobody else has.",
    "home.train.step1": "Upload your samples",
    "home.train.step1Sub": "A short clip of clear vocals is all you need",
    "home.train.step2": "We train your model",
    "home.train.step2Sub": "Your custom voice is ready in minutes",
    "home.train.step3": "Make covers with it",
    "home.train.step3Sub": "Use it in your covers, whenever you want",

    "home.topCollections": "Top collections",
    "home.collabs": "Trending collabs",
    "home.collection": "Collection",

    // Cards (components/home/JamCards.tsx)
    "home.card.uses": "{n} uses",
    "home.card.voices": "{n} voices",
    "home.card.likes": "{n} likes",
    "home.card.by": "by @{user}",
    "home.card.madeToday": "{n} made today",
    "home.card.makeDuet": "Make this duet",

    // Discord CTA (components/DiscordCta.js)
    "home.discord.bannerSub":
      "Share covers, request voices and get help from the community",
    "home.discord.online": "{n} online",
    "home.discord.members": "{n} members",
    "home.discord.joinDiscord": "Join Discord",
    "home.discord.softSub": "Share covers, request voices, get tips",
    "home.discord.cardSub": "Get help, share covers, find new voices",
    "home.discord.join": "Join",
  },
  es: {
    "home.seo.title":
      "Jammable: Voces IA para Covers, Cambiar tu Voz y Clonar Voces",
    "home.seo.description":
      "Más de 100,000 voces IA de cantantes, personajes y famosos. Haz covers con IA, cambia tu voz o clona la tuya. Escuchar las voces es gratis.",
    "home.seo.ogTitle":
      "Jammable: Voces IA para Covers, Cambiar tu Voz y Clonar Voces",
    "home.seo.imageAlt": "Jammable: crea covers con IA",

    "home.hero.views":
      "Más de 10 mil millones de vistas en TikTok, YouTube e Instagram",
    "home.hero.titleBefore": "Crea",
    "home.hero.titleHighlight": "covers con IA",
    "home.hero.titleAfter": "con tus voces favoritas",
    "home.hero.subtitle":
      "Elige entre más de 100,000 voces IA, agrega tu audio y recibe tu cover en segundos.",
    "home.hero.decorVoice": "Voz IA",
    "home.hero.decorCover": "cover",
    "home.hero.searchLabel": "Buscar voces",
    "home.hero.searchPlaceholder": "Busca entre más de 100,000 voces",
    "home.hero.searchButton": "Buscar",
    "home.hero.makeCover": "Hacer un cover",

    "home.categories.all": "Ver todas las categorías",
    "home.recent": "Continúa donde lo dejaste",
    "home.trending": "Tendencias ahora",
    "home.seeAll": "Ver todas",

    "home.train.kicker": "Más de 100,000 voces empezaron así",
    "home.train.titleBefore": "Entrena tu propia",
    "home.train.titleHighlight": "voz IA",
    "home.train.body":
      "Crea una voz con unas pocas muestras y haz covers con una voz que nadie más tiene.",
    "home.train.step1": "Sube tus muestras",
    "home.train.step1Sub": "Solo necesitas un clip corto con la voz clara",
    "home.train.step2": "Entrenamos tu modelo",
    "home.train.step2Sub": "Tu voz personalizada está lista en minutos",
    "home.train.step3": "Haz covers con ella",
    "home.train.step3Sub": "Úsala en tus covers cuando quieras",

    "home.topCollections": "Colecciones destacadas",
    "home.collabs": "Colaboraciones en tendencia",
    "home.collection": "Colección",

    "home.card.uses": "{n} usos",
    "home.card.voices": "{n} voces",
    "home.card.likes": "{n} me gusta",
    "home.card.by": "de @{user}",
    "home.card.madeToday": "{n} covers hoy",
    "home.card.makeDuet": "Hacer este dueto",

    "home.discord.bannerSub":
      "Comparte covers, pide voces y recibe ayuda de la comunidad",
    "home.discord.online": "{n} en línea",
    "home.discord.members": "{n} miembros",
    "home.discord.joinDiscord": "Únete a Discord",
    "home.discord.softSub": "Comparte covers, pide voces, recibe consejos",
    "home.discord.cardSub":
      "Recibe ayuda, comparte covers, descubre voces nuevas",
    "home.discord.join": "Unirme",
  },
  pt: {
    "home.seo.title":
      "Jammable: Vozes de IA para Covers, Modificador de Voz e Clonar Voz",
    "home.seo.description":
      "Mais de 100 mil vozes de IA de cantores, personagens e famosos. Faça covers com IA, mude sua voz ou clone a sua. Ouvir as vozes é grátis.",
    "home.seo.ogTitle":
      "Jammable: Vozes de IA para Covers, Modificador de Voz e Clonar Voz",
    "home.seo.imageAlt": "Jammable: crie covers com IA",

    "home.hero.views":
      "Mais de 10 bilhões de visualizações no TikTok, YouTube e Instagram",
    "home.hero.titleBefore": "Crie",
    "home.hero.titleHighlight": "covers com IA",
    "home.hero.titleAfter": "com suas vozes favoritas",
    "home.hero.subtitle":
      "Escolha entre mais de 100 mil vozes de IA, adicione seu áudio e receba seu cover em segundos.",
    "home.hero.decorVoice": "Voz de IA",
    "home.hero.decorCover": "cover",
    "home.hero.searchLabel": "Buscar vozes",
    "home.hero.searchPlaceholder": "Busque entre mais de 100 mil vozes",
    "home.hero.searchButton": "Buscar",
    "home.hero.makeCover": "Fazer um cover",

    "home.categories.all": "Ver todas as categorias",
    "home.recent": "Continue de onde parou",
    "home.trending": "Em alta agora",
    "home.seeAll": "Ver todas",

    "home.train.kicker": "Mais de 100 mil vozes começaram assim",
    "home.train.titleBefore": "Treine sua própria",
    "home.train.titleHighlight": "voz de IA",
    "home.train.body":
      "Crie uma voz com algumas amostras e faça covers com uma voz que ninguém mais tem.",
    "home.train.step1": "Envie suas amostras",
    "home.train.step1Sub": "Basta um clipe curto com a voz bem limpa",
    "home.train.step2": "Treinamos seu modelo",
    "home.train.step2Sub": "Sua voz personalizada fica pronta em minutos",
    "home.train.step3": "Faça covers com ela",
    "home.train.step3Sub": "Use nos seus covers quando quiser",

    "home.topCollections": "Coleções em destaque",
    "home.collabs": "Colaborações em alta",
    "home.collection": "Coleção",

    "home.card.uses": "{n} usos",
    "home.card.voices": "{n} vozes",
    "home.card.likes": "{n} curtidas",
    "home.card.by": "por @{user}",
    "home.card.madeToday": "{n} covers hoje",
    "home.card.makeDuet": "Fazer este dueto",

    "home.discord.bannerSub":
      "Compartilhe covers, peça vozes e tire dúvidas com a comunidade",
    "home.discord.online": "{n} online",
    "home.discord.members": "{n} membros",
    "home.discord.joinDiscord": "Entrar no Discord",
    "home.discord.softSub": "Compartilhe covers, peça vozes, receba dicas",
    "home.discord.cardSub":
      "Tire dúvidas, compartilhe covers, descubra novas vozes",
    "home.discord.join": "Entrar",
  },
};
